export default {"src":"/_next/static/media/linkedin.210b4392.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};